import { Grid, IconButton } from "@mui/material";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { useLinks } from "hooks/useLinks";
import { appleStoreIconPath, googleStoreIconPath } from "utils/svgIcons";

export const FooterAppStoreButtons = () => {
	const links = useLinks();
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();

	return (
		<Grid
			item
			py={2}
			sx={{
				padding: "16px"
			}}
		>
			<Grid
				container
				spacing={0.8}
				direction="row"
				alignItems="center"
				justifyContent="center"
			>
				<Grid item xs={6} textAlign="center">
					<IconButton
						onClick={() => {
							reportEvent("apple_store_click", { source: "footer" });
							reportPlaygamiEvent("tp.web_frontend", {
								event_name: links.appstore_apple.analytics_key,
								event_type: "footer",
								action: links.appstore_apple.analytics_key,
								source: "footer"
							});
						}}
						component="a"
						href={links.appstore_apple.path}
						title="iOS App Store"
						target="_blank"
						rel="noreferrer"
						sx={{
							padding: "0px"
						}}
					>
						<img src={appleStoreIconPath} alt="Apple App Store page" />
					</IconButton>
				</Grid>
				<Grid item xs={6} textAlign="center">
					<IconButton
						onClick={() => {
							reportEvent("google_play_store_click", { source: "footer" });
							reportPlaygamiEvent("tp.web_frontend", {
								event_name: links.appstore_google.analytics_key,
								event_type: "footer",
								action: links.appstore_google.analytics_key,
								source: "footer"
							});
						}}
						component="a"
						href={links.appstore_google.path}
						title="Google Play Store"
						target="_blank"
						rel="noreferrer"
						sx={{
							padding: "0px"
						}}
					>
						<img src={googleStoreIconPath} alt="Google App Store page" />
					</IconButton>
				</Grid>
			</Grid>
		</Grid>
	);
};
